import { Modal, Button } from "react-bootstrap";

const DeleteModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center p-4">
        <h5>Are you sure?</h5>
        <p>You want to delete this activity</p>

        <div className="d-flex justify-content-center gap-2 mt-3">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-danger">
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;